module.exports = __webpack_public_path__ + "img/已完成.290e8189.png";